import { CardCvcElement, CardExpiryElement, CardNumberElement } from '@stripe/react-stripe-js';
import { createFormStripeElement } from './createFormStripeElement.tsx';

export const FormStripeCardCVCElement = createFormStripeElement(CardCvcElement);

export const FormStripeCardExpiryElement = createFormStripeElement(CardExpiryElement);

export const FormStripeCardNumberElement = createFormStripeElement(CardNumberElement);
